import { useEffect } from 'react';

import CombineProvider from 'hb-react/shared/components/CombineProvider';
import App from 'hb-react/shared/providers/App';
import QueryClientProvider from 'hb-react/shared/providers/QueryClient';
import { useLaunchDarklyProviderConfig } from 'hb-react/shared/utils/launchDarkly';

const Providers = (props) => {
  const { status, providerConfig } = useLaunchDarklyProviderConfig();

  useEffect(() => {
    if (!window.publicHistory) {
      window.publicHistory = {
        navigate: (url) => {
          // Navigates the browser to new location, so it does make a new http request, which refreshes the browser.
          window.location.href = url;
        },
      };
    }
  }, []);

  // Launchdarkly flags fetch is required to render the app
  return status === 'success' ? (
    // Use CombineProvider to naturally remove LD Provider in local when providerConfig is null
    <CombineProvider providers={[providerConfig]}>
      <App {...props} theme="po" />
    </CombineProvider>
  ) : null;
};

const PublicOfficeApp = (props) => (
  <QueryClientProvider>
    <Providers {...props} />
  </QueryClientProvider>
);

export default PublicOfficeApp;
